import React, { createContext, useState } from 'react'

export const ImageSearchContext = createContext({});

export const ImageSearchContextProvider = ({ children }) => {
    const [searchQueryContext, setSearchQueryContext] = React.useState({
        accountNumber: null,
        lockboxNumber: null,
        lockboxSite: null,
        processedDateFrom: null,
        processedDateTo: null,
        batchNumberFrom: null,
        batchNumberTo: null,
        batchAmountFrom: null,
        batchAmountTo: null,
        checkNumberFrom: null,
        checkNumberTo: null,
        amountFrom: null,
        amountTo: null,
        abaRoutingNumber: null,
        checkingAccountNumber: null,
        customerIdentifier: null,
        payeeName: null,
        invoiceNumber: null,
        defaultSearch: false,
        processedDateRange: null
    })
    const [screen, setScreen] = useState(1)

    return <ImageSearchContext.Provider value={{searchQueryContext, setSearchQueryContext, screen, setScreen}}>
        {children}
    </ImageSearchContext.Provider>
}